import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { MigrationStrategies, RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';

export interface ViewInspector {
  readonly pk_ScheduleLeadFieldInspector?: string;
  readonly workPackageId?: number;
  readonly leadInspectorId?: number;
  readonly fieldInspectorId?: number;
  readonly fieldInspectorName: string;
  readonly isActive?: boolean;
  readonly disciplineId?: number;
  readonly siteId?: number;
  readonly isAddedBySP?: boolean;
  readonly serviceProviderId?: number;
  readonly organizationName?: string;
  readonly dateCreated?: string;
  readonly dateModified?: string;
  readonly clerkName?: string;
  readonly clerkId?: number;
  readonly clerkServiceProviderId?: number;
}

export const viewInspectorSchema: RxJsonSchema<ViewInspector> = {
  type: 'object',
  version: 1,
  description: 'describes work package',
  primaryKey: 'pk_ScheduleLeadFieldInspector',
  properties: {
    pk_ScheduleLeadFieldInspector: { type: 'string', maxLength: 36 },
    workPackageId: { type: 'number' },
    leadInspectorId: { type: ['number', 'null'] },
    fieldInspectorId: { type: ['number', 'null'] },
    clerkId: { type: ['number', 'null'] },
    clerkServiceProviderId: { type: ['number', 'null'] },
    clerkName: { type: ['string', 'null'] },
    fieldInspectorName: { type: ['string', 'null'] },
    isAddedBySP: { type: ['boolean', 'null'] },
    serviceProviderId: { type: ['number', 'null'] },
    organizationName: { type: ['string', 'null'] },
    siteId: { type: ['number', 'null'] },
    disciplineId: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};

export const viewInspectorMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: ViewInspectorDocument) => {
    const newDoc = {
      ...oldDoc,
      clerkName: oldDoc.clerkName || null,
      clerkId: oldDoc.clerkId || null,
      clerkServiceProviderId: oldDoc.clerkServiceProviderId || null,
    };
    return newDoc;
  },
};

export type ViewInspectorCollection = RxCollection<ViewInspector> | null;
export type ViewInspectorDocument = RxDocument<ViewInspector>;

export const viewInspectorPullQueryBuilder = (document: ViewInspector) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query mobileFieldInspectorFeed(
      $siteId: Int!
      $disciplineId: Int!
      $lastRequested: DateTime!
      $isLeadInspector: Boolean!
    ) {
      mobileFieldInspectorFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
        isLeadInspector: $isLeadInspector
      ) {
        pk_ScheduleLeadFieldInspector
        workPackageId
        leadInspectorId
        fieldInspectorId
        fieldInspectorName
        isActive
        disciplineId
        siteId
        isAddedBySP
        serviceProviderId
        organizationName
        dateCreated
        dateModified
        clerkName
        clerkId
        clerkServiceProviderId
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.siteId,
        doc.disciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  };
};

export default {};
